module.exports = __webpack_public_path__ + "img/21.8c872111.jpg";